import Spinner from 'builder/components/Spinner'
import DocumentIcon from '../Icons/ResumeThumbnail.png'
import {
  DocumentPlaceholderOverlay,
  DocumentThumbnail,
  ThumbnailPlaceholderContainer,
} from './styles'

export const DocumentThumbnailPlaceholder = () => {
  return (
    <ThumbnailPlaceholderContainer>
      <DocumentPlaceholderOverlay>
        <Spinner />
      </DocumentPlaceholderOverlay>
      <DocumentThumbnail src={DocumentIcon} />
    </ThumbnailPlaceholderContainer>
  )
}
